import { useLocation } from 'react-router-dom';

/**
 * Returns the route prefix for diligência pages based on the current
 * pathname. The same admin diligência components are mounted under both
 * /admin and /diligencias-manager, so navigate() calls need the matching
 * prefix instead of a hardcoded /admin path.
 */
export function useDiligenciasBasePath(): string {
  const { pathname } = useLocation();
  if (pathname.startsWith('/diligencias-manager')) {
    return '/diligencias-manager/diligencias';
  }
  return '/admin/diligencias';
}
